import { Field, FieldArray, Form, Formik } from "formik";
import { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";
import { addHomeDataAction } from "../actions";
import { toolType } from "../types";
import { AddTools } from "./AddTools";
import { FeaturesList } from "./FeaturesList";

type editToolType = {
  index: number;
  tool: toolType;
};

const toolboxSchema = Yup.object({
  // who_title: Yup.string().required("Title can not be empty"),
  // tool_description: Yup.string().required("Paragraph can not be empty"),
  // who_button_title: Yup.string().required("Button title can not be empty"),
  // tools: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       title: Yup.string().required("title can not be empty"),
  //       color: Yup.string().required("color can not be empty"),
  //       video: Yup.string().required("video can not be empty"),
  //       bottom_text: Yup.string().required("animation text can not be empty"),
  //     })
  //   )
  //   .required("items can not be empty")
  //   .min(3, "please add minimum 3 items")
  //   .max(3, "you can add max 3 items"),
});

const ToolboxSection = ({ props }: any) => {
  const [toolEdit, setToolEdit] = useState<boolean>(false);
  const [editTool, setEditTool] = useState<editToolType | null>(null);

  const dispatch = useDispatch();
  const toolbox_state = useSelector((state: any) => state?.home?.home_data);
  const toolboxState = {
    tool_header: toolbox_state?.tool_header ? toolbox_state?.tool_header : "",
    tool_description: toolbox_state?.tool_description ? toolbox_state?.tool_description : "",
    tool_button: toolbox_state?.tool_button ? toolbox_state?.tool_button : "",
    tool_button_link: toolbox_state?.tool_button_link ? toolbox_state?.tool_button_link : "",
    tools: toolbox_state?.tools ? toolbox_state?.tools : [],
  };

  const handleToolboxSubmit = (values: any) => {
    if ((!values.tool_button && values.tool_button_link) || (values.tool_button && !values.tool_button_link)) {
      toast.error("Please validate the form");
    } else {
      let newFeaturesArray: any = values?.tools?.map((tool: any) => {
        if (tool.features && Array.isArray(tool.features)) {
          const updatedFeatures: any = tool.features.map(({ dummyImage, oldImage, ...rest }) => rest);
          return { ...tool, features: updatedFeatures };
        }
        return tool;
      });

      let newToolsArray: any = newFeaturesArray.map(({ dummyImage, oldImage, ...rest }) => rest);
      const form_data = new FormData();
      form_data.append("id", "tool");
      form_data.append("tool_header", values.tool_header);
      form_data.append("tool_description", values.tool_description);
      form_data.append("tool_button", values.tool_button);
      form_data.append("tool_button_link", values.tool_button_link);
      form_data.append("tools", JSON.stringify(newToolsArray));
      dispatch(addHomeDataAction(form_data, setToolEdit, "add-toolbox-section"));
      console.log("global_values", values, newToolsArray);
      setToolEdit(false);
    }
  };
  return (
    <Formik enableReinitialize initialValues={toolboxState} validationSchema={toolboxSchema} onSubmit={handleToolboxSubmit}>
      {({ values, handleChange, setFieldValue, handleBlur }) => {
        return (
          <>
            <Form>
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h6 className={`mb-0 fs-lg ${toolEdit ? "editTitle" : ""}`}>Toolbox Section</h6>
                  {toolEdit ? (
                    <button className="btn btn-primary" type="submit">
                      <i className="fa-regular fa-floppy-disk"></i> Save
                    </button>
                  ) : (
                    <span onClick={() => setToolEdit(true)} className="btn btn-green">
                      <i className="fa-regular fa-pen-to-square"></i> Edit
                    </span>
                  )}
                </Card.Header>
                <Card.Body className="position-relative">
                  <div
                    className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${toolEdit ? "d-none" : ""}`}
                    style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                  ></div>
                  <Row className="gy-3">
                    <Col xs={12}>
                      <label className="form-label">Header</label>
                      <Field
                        name="tool_header"
                        component={TextInput}
                        value={values.tool_header}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header"
                        readOnly={!toolEdit}
                        className={toolEdit ? "editField" : ""}
                      />
                    </Col>
                    <Col xs={12}>
                      <label className="form-label">Header Description</label>
                      <Field
                        name="tool_description"
                        component={TextInput}
                        value={values.tool_description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header description"
                        readOnly={!toolEdit}
                        className={toolEdit ? "editField" : ""}
                        multiline
                      />
                    </Col>
                    <Col sm={4}>
                      <label className="form-label">Button</label>
                      <Field
                        name="tool_button"
                        component={TextInput}
                        value={values.tool_button}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button"
                        readOnly={!toolEdit}
                        className={toolEdit ? "editField" : ""}
                      />
                      {!values.tool_button && values.tool_button_link ? <div className="errorMessage">Enter button text</div> : null}
                    </Col>
                    <Col sm={8}>
                      <label className="form-label">Button Link</label>
                      <Field
                        name="tool_button_link"
                        component={TextInput}
                        value={values.tool_button_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button link"
                        readOnly={!toolEdit}
                        className={toolEdit ? "editField" : ""}
                      />
                      {values.tool_button && !values.tool_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Form>
            <FieldArray
              name="tools"
              render={(arrayHelpers) => (
                <>
                  <div className="position-relative">
                    <div
                      className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${toolEdit ? "d-none" : ""}`}
                      style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                    ></div>
                    <AddTools
                      uploadAction={props.uploadFileAction}
                      uploadNewAction={props.uploadFileNewAction}
                      editTool={editTool}
                      setEditTool={setEditTool}
                      customHelpers={arrayHelpers}
                      setFieldValue={setFieldValue}
                      edit={toolEdit}
                    />
                    <FeaturesList values={values} customHelpers={arrayHelpers} setEditTool={setEditTool} edit={toolEdit} />
                  </div>
                </>
              )}
            />
          </>
        );
      }}
    </Formik>
  );
};

export default ToolboxSection;
